module.exports = __webpack_public_path__ + "static/media/logo_text_white.d2875259.png";